// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 464) return "static/chunks/464-69199cf32ad4394f.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 79 ? "363642f4" : chunkId) + "." + {"79":"c98300e209aa8f0c","384":"eb885b331075d062","461":"36f953b511e9b74f","541":"15b881e86a98d40a"}[chunkId] + ".js";
};